import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUsers, requestLocationChange, addErrorMessage } from '../actions';
import Config from '../Config';

import Logo from '../components/Logo';

// Material UI Libraries
import RaisedButton from 'material-ui/RaisedButton';

class Login extends Component {

  componentWillMount() {
    // Check for token from google auth callback
    if (
      this.props.location.get('options')
      && this.props.location.get('options').get('token')
    ) {
      localStorage.setItem('authToken', this.props.location.get('options').get('token'));
      this.props.dispatch(requestLocationChange('home'));
    } else if (
      this.props.location.get('options')
      && this.props.location.get('options').get('login_error')
    ) {
      this.handleLoginError();
    }
  }

  handleLoginError = () => {
    switch (this.props.location.get('options').get('login_error')) {
      case 'invalid_account':
        this.props.dispatch(addErrorMessage({
          type: 'Unauthorized',
          message: 'No account exists for that email, please request access from an admin.',
          autoHideDuration: 10000,
        }));
        break;
      default:

    }
  };

  render() {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <Logo width="400" height="240" scale="0.25" />
        <h1>Please Login</h1>
        <RaisedButton
          secondary={true}
          buttonStyle={{ color: 'white' }}
          href={`${Config.apiBase}/users/auth/google_oauth2?callback_url=${window.encodeURIComponent(window.location.origin)}/login`}
        >
          Login
        </RaisedButton>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    location: state.get('location'),
  };
}

export default connect(mapStateToProps)(Login);



/** WEBPACK FOOTER **
 ** ./containers/Login.js
 **/